const selector = '.block-testimonial-standard .slick-arrow';

function moveArrow(arrow) {
  if (window.matchMedia("(max-width: 767px)").matches && !arrow.offsetParent.offsetParent.classList.contains('no-image')) {
    const slideInner = arrow.parentElement.querySelector('.slick-current');
    const sliderTrack = arrow.parentElement.querySelector('.slick-list');
    const difference = sliderTrack.clientHeight - slideInner.clientHeight;
    
    arrow.style.transform = `translateY(-${difference}px)`;
  }
  else {
    arrow.style.transform = `translateY(0px)`;
  }
}

function moveArrows() {
  const arrows = document.querySelectorAll(selector);

  arrows.forEach((arrow) => {
    moveArrow(arrow);
  });
}

function setArrowPosition() {
  const arrows = document.querySelectorAll(selector);

  arrows.forEach((arrow) => {
    moveArrow(arrow);

    arrow.addEventListener('click', () => {
      moveArrows();
    });
  });
}

// GLOBAL APP CONTROLLER
const controller = {
  init() {},
  DOMLoaded() {
    setArrowPosition();
  },
  loaded() {},
  resized() {
    moveArrows();
  },
  scrolled() {},
  keyDown() {},
  mouseUp() {
    moveArrows();
  },
};
export default controller;
